var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{attrs:{"name":"login-registration-force","width":300,"height":"auto","click-to-close":false}},[_c('LoginRegistrationModalContent',{attrs:{"init-tab":"registration"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }